<img [src]="icon" alt="{{ iconAlt }}" class="icon-fluid" loading="lazy" />
